var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-date-picker',{staticStyle:{"width":"18rem"},attrs:{"type":"daterange","range-separator":"~","start-placeholder":"Start date","end-placeholder":"End date","size":"small"},on:{"change":_vm.filterClosePriceByDateRange},model:{value:(_vm.dateRange),callback:function ($$v) {_vm.dateRange=$$v},expression:"dateRange"}})
}
var staticRenderFns = []

export { render, staticRenderFns }